import * as React from "react";
import PropTypes from "prop-types";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Collection from "nexia_mobile/framework/collection";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";
import DumbModeList from "./DumbModeList";

export default class ModeList extends React.Component {
  static propTypes = {
    modesCollection: PropTypes.instanceOf(Collection).isRequired,
    onFinished: PropTypes.func.isRequired,
  };

  render() {
    const { modesCollection, onFinished } = this.props;

    return (
      <BackboneListener
        listenTo={modesCollection}
        events={["add", "remove", "reset", "sort", "sync", "change"]}
        debounceRender
      >
        {() => (
          <DumbModeList
            modes={modesCollection.map((mode) => {
              const icons = parseIconsFromServer(mode.get("icon"));
              let icon = null;
              if (icons.length > 0) {
                icon = icons[0].element;
              }

              return {
                id: mode.get("id"),
                name: mode.get("name"),
                icon,
                isSelected: mode.get("enabled"),
              };
            })}
            onModeSelected={(id) => {
              const mode = modesCollection.findWhere({ id });
              Dispatch(
                "RUN_PROMISE_WITH_SPINNER",
                () => {
                  return modesCollection
                    .setActiveMode(mode)
                    .then(onFinished, onFinished);
                },
                `Setting mode to '${mode.get("name")}'`
              );
            }}
          />
        )}
      </BackboneListener>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/ModeSelector/ModeList.jsx